// Initialize Sentry before other imports
import './sentry';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { getDB } from './lib/db';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for offline capabilities
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker registered successfully:', registration.scope);
      })
      .catch((error) => {
        console.error('Service Worker registration failed:', error);
      });
  });
}

// Initialize IndexedDB for offline storage
getDB()
  .then(() => {
    console.log('IndexedDB initialized successfully');
  })
  .catch((error) => {
    console.error('IndexedDB initialization failed:', error);
  });
